/* eslint-disable */
import KeenSlider from 'keen-slider';
import gsap from 'gsap';

export default function initDyanmicResourceCenter() {

    const sections = document.querySelectorAll('.dynamic-resource-center');

    sections.forEach(section => {

        const controls = section.querySelector('.carousel-controls');
        const tabnav = section.querySelectorAll('.tab-nav-tabs li');
        const prevBtn = section.querySelector('.carousel-nav-prev');
        const nextBtn = section.querySelector('.carousel-nav-next');
        const carouselElement = section.querySelector('.carousel');
        const hiddenDiv = document.createElement('ul');
        const indicatorsContainer = section.querySelector('.carousel-controls-indicators');

        let carousel;
        let carouselOptions;
        let allSlides;
        let slides;

        const AccesibilityPlugin = (slider) => {

            const slides = slider.slides;

            const onMove = (e) => {
                const slidesData = slider.track.details.slides;
                for (let i = 0; i < slides.length; i++) {
                    slides[i].setAttribute('aria-hidden', false);
                }
            };

            const onRest = (e) => {
                const slidesData = slider.track.details.slides;

                for (let i = 0; i < slides.length; i++) {
                    const slideData = slidesData[i];
                    slides[i].setAttribute('aria-hidden', (slideData?.portion === 0));
                }
            }

            slider.on('created', () => {
                setTimeout(onRest, 200);

                for (let i = 0; i < slides.length; i++) {

                    slides[i].addEventListener('focusin', (e) => {
                        if (e.target.matches(':focus-visible')) {
                            slider.moveToIdx(i);
                        }
                        // move keen slider to this slide
                        //slider.moveToSlide(i);
                    });

                }
            });
            slider.on('slideChanged', onRest);
            slider.on('dragStart', onMove);
            slider.on('animationStarted', onMove);
            slider.on('animationEnded', onRest);
            // slider.on('updated', {} );

        };

        const WheelControlsPlugin = (slider) => {

            let touchTimeout, position, wheelActive;

            const dispatch = (e, name) => {
                position.x -= e.deltaX;
                position.y -= e.deltaY;
                slider.container.dispatchEvent(new CustomEvent(name, { detail: { x: position.x, y: position.y } }));
            };

            const wheelStart = (e) => {
                position = { x: e.pageX, y: e.pageY };
                dispatch(e, "ksDragStart");
            };

            const wheel = (e) => dispatch(e, "ksDrag");
            const wheelEnd = (e) => dispatch(e, "ksDragEnd");

            const eventWheel = (e) => {
                if (e.deltaX === 0) return false;

                e.preventDefault();
                if (!wheelActive) {
                    wheelStart(e);
                    wheelActive = true;
                }
                wheel(e);
                clearTimeout(touchTimeout);
                touchTimeout = setTimeout(() => {
                    wheelActive = false;
                    wheelEnd(e);
                }, 50);
            };

            slider.on("created", () => {
                slider.container.addEventListener("wheel", eventWheel, { passive: false });
            });
        };

        const init = () => {
            section.appendChild(hiddenDiv);
            hiddenDiv.style.display = 'none';
			const contentTypeFilter = section.querySelector('select.content-type');

			tabnav.forEach((tab,i)=> {
                tab.addEventListener('click', (e) => {
                    e.preventDefault();
					//reset the content type filter on topic change
					const contentTypeFilter = section.querySelector('select.content-type');
					contentTypeFilter.value = "";
                    filterResults( e.currentTarget.attributes['term'].value );
                });
            });

			contentTypeFilter.addEventListener('change', (e) => {
				let filter = section.querySelector('.tab-nav-tabs .active')?.attributes['term']?.value ;
				filterResults(filter);
			});

            allSlides = slides = carouselElement.querySelectorAll('.carousel-slide');
            allSlides.forEach((slide, i) => {
                slide.dataset.order = i;
            });

            carouselOptions = {
                selector: slides,
                defaultAnimation: {
                    duration: 1000,
                },
                slides: { perView: 1, spacing: 10, origin: 'auto' },
                mode: "free-snap",
                drag: true,
                loop: false,
                renderMode: 'precision',
                rubberband: false,
                centered: true,
                breakpoints: {
                    '(min-width: 576px)': {
                        drag: true,
                        loop: false,
                        slides: { perView: 2, spacing: 10 }
                    },
                    '(min-width: 769px)': {
                        centered: true,
                        slides: { perView: 2, spacing: 10 }
                    },
                    '(min-width: 1024px)': {
                        slides: { perView: 3, spacing: 10 }
                    },
                    '(min-width: 1200px)': {
                        slides: { perView: 4, spacing: 10 }
                    },
                    '(min-width: 1400px)': {
                        slides: { perView: 4, spacing: 10 }
                    },
                },
                detailsChanged: (s) => {
                    // console.log(s.track.details );
                    const indicators = indicatorsContainer.querySelectorAll('li');
                    indicators.forEach((indicator, i) => {
                        if (i === s.track.details?.abs) {
                            indicator.classList.add('active');
                        } else {
                            indicator.classList.remove('active');
                        }
                    });

                    if (s.track.details?.abs === s.track.details?.maxIdx) {
                        nextBtn.classList.add('disabled');
                    } else {
                        nextBtn.classList.remove('disabled');
                    }

                    if (s.track.details?.abs === 0) {
                        prevBtn.classList.add('disabled');
                    } else {
                        prevBtn.classList.remove('disabled');
                    }
                },
            };

            carousel = new KeenSlider(carouselElement, carouselOptions, [WheelControlsPlugin, AccesibilityPlugin]);
            carousel.moveToIdx(0);

            prevBtn.addEventListener('click', (e) => {
                e.preventDefault();
                carousel.prev();
            });

            nextBtn.addEventListener('click', (e) => {
                e.preventDefault();
                carousel.next();
            });

            updateUI();
			updateContentTypeDropdown();

            window.addEventListener('resize', () => {
                updateUI();
            });
        };

		const updateContentTypeDropdown = (contentType) => {
			let foundTypes = [];
			const contentTypeFilter = section.querySelector('select.content-type');
			let term = section.querySelector('.tab-nav-tabs .active')?.attributes['term']?.value;
            allSlides.forEach((slide, i) => {
				if(term === 'all' || slide.attributes['term'].value === term ){
					foundTypes.push(slide.attributes['content_type'].value);
				}
			});

			foundTypes = [...new Set(foundTypes)];
			const options = contentTypeFilter.options;
			for (let i = options.length; i--;) {
				const option = options[i];
				if (!foundTypes.includes(option.value)) {
					option.disabled = true;
				}else{
					option.disabled = false;
				}
			}

			if(foundTypes.length <= 1 ){
				contentTypeFilter.value = foundTypes[0];
				contentTypeFilter.style.display = 'none';
			}else{
				contentTypeFilter.style.display = 'block';
			}
		};

        const filterResults = (term) => {
			const contentTypeFilter = section.querySelector('select.content-type');
			let contentType = contentTypeFilter.value;

            tabnav.forEach((tab, i) => {
                if (tab.attributes['term'].value === term) {
                    tab.classList.add('active');
                } else {
                    tab.classList.remove('active');
                }
            });
			// console.log(term);

            allSlides.forEach((slide, i) => {
                if( term === 'all' && contentType === "") {
                    // move all children from hiddenDiv to carousel
                    hiddenDiv.childNodes.forEach((child) => {
                        carouselElement.appendChild(child);
                    });

                    return;
                }
				let keep = false;
                if (slide.attributes['term'].value === term || term === 'all') {
					keep = true;
                }
				if(keep && contentType !== ""){
					if (slide.attributes['content_type'].value === contentType) {
						keep = true;
					}else{
						keep = false;
					}
				}
				if(keep){
                    carouselElement.appendChild(slide);
				}else{
					hiddenDiv.appendChild(slide);
				}
            });

            let unorderedSlides = carouselElement.querySelectorAll('.carousel-slide');
            unorderedSlides = Array.from(unorderedSlides).sort((a, b) => a.dataset.order - b.dataset.order);
            unorderedSlides.forEach((slide, i) => {
                carouselElement.appendChild(slide);
            });

            slides = carouselElement.querySelectorAll('.carousel-slide');

            carouselOptions.selector = slides;
            carousel.update(carouselOptions, 0);

            updateUI();
			updateContentTypeDropdown();

        };

        const updateUI = () => {
            indicatorsContainer.innerHTML = '';
            let maxIndicators = carousel.track.details.maxIdx + 1;


            for (let i = 0; i < maxIndicators ; i++ ) {
                const indicator = document.createElement('li');
                indicator.classList.add('carousel-indicator');
                indicator.setAttribute('data-slide', i);
                indicator.addEventListener('click', (e) => {
                    e.preventDefault();
                    carousel.moveToIdx(i);
                });
                indicatorsContainer.appendChild(indicator);

                if (i === 0) {
                    indicator.classList.add('active');
                }
            }

            gsap.to(controls, { duration: 0.5, autoAlpha: (carousel.track.details?.maxIdx == 0) ? 0 : 1 });
        };

        init();

    });

}
